// =====================================================
// KB-MASSENTEXT.JS - EXCEL UPLOAD FOR PRODUCT PAGE
// Version with BATCH processing for better performance
// =====================================================
// Language detection function
function getCurrentLanguage() {
  const domain = window.location.hostname;
  if (domain.includes("dk.toproset.eu")) return "dk";
  if (domain.includes("nl.toproset.eu")) return "nl";
  if (domain.includes("es.toproset.eu")) return "es";
  if (domain.includes("en.toproset.eu")) return "en";
  return "de";
}

// Translation strings
const TRANSLATIONS = {
  de: {
    buttonText: "📊 Excel/CSV",
    modalTitle: "Excel/CSV Datei hochladen",
    uploadDragDrop: "Drag & Drop eine Excel/CSV Datei hier oder klicken Sie zum Auswählen",
    uploadSelectFile: "Datei auswählen",
    uploadSupportedFormats: "Unterstützte Formate:",
    settingsTitle: "Einstellungen",
    settingsMaxRows: "Max. Zeilen:",
    settingsMaxLength: "Max. Textlänge:",
    settingsMaxLengthUnit: "Zeichen",
    settingsBatchSize: "Batch-Größe:",
    settingsBatchUnit: "Artikel pro Anfrage",
    currentSettingsTitle: "Aktuelle Produkteinstellungen:",
    currentSettingsNone: "Keine spezifischen Einstellungen",
    previewTitle: "Datenvorschau",
    previewRow: "Zeile",
    previewTexts: "Texte",
    previewQty: "Qty",
    previewActive: "Aktiv",
    previewAction: "Aktion",
    previewText: "Text",
    previewTruncated: "(gekürzt von",
      propertySelectors: [
    'properties[Druckposition Band]',
    'properties[_Aufdruck-Option]', 
    'properties[_Druckvorlage vorhanden]',
    'properties[Artikelnr. der Vorlage]',
    'properties[Text]'
    ],
    controlSelectAll: "Alle auswählen",
    controlDeselectAll: "Alle abwählen",
    controlDeleteSelected: "Ausgewählte löschen",
    btnCancel: "Abbrechen",
    btnConfirm: "In den Warenkorb",
    inputSelector: "_Aufdruck-Option",
    massentextValue: 'Massentext',
    msgProcessing: "Datei wird verarbeitet...",
    msgProcessingError: "Fehler beim Verarbeiten",
    msgInvalidType: "Ungültiger Dateityp.",
    msgNoData: "Keine Daten gefunden.",
    msgWarningTooManyRows: "⚠️ Warnung: Datei enthält {total} Zeilen, aber nur die ersten {max} werden verarbeitet.",
    msgNoValidText: "Keine gültigen Textdaten gefunden.",
    msgRowsLoaded: "{count} Zeilen erfolgreich geladen.",
    msgNoActiveRows: "Keine aktiven Zeilen zum Hinzufügen.",
    msgVariantNotFound: "Fehler: Variant ID nicht gefunden.",
    msgAllAdded: "Alle {count} Positionen erfolgreich hinzugefügt ({total} Artikel total)!",
    msgPartialAdded: "{success} von {total} Positionen erfolgreich hinzugefügt ({items} Artikel total)!",
    msgWithErrors: " ({errors} Fehler)",
    msgAddError: "Fehler beim Hinzufügen der Artikel.",
    msgUnexpectedError: "Unerwarteter Fehler beim Hinzufügen der Artikel.",
    msgConfirmDelete: "Möchten Sie diese Zeile wirklich löschen?",
    msgRowDeleted: "Zeile gelöscht. {count} Zeilen verbleiben.",
    msgAllDeleted: "Alle Zeilen wurden gelöscht.",
    msgNoRowsToDelete: "Keine Zeilen zum Löschen ausgewählt.",
    msgConfirmDeleteMultiple: "Möchten Sie {count} ausgewählte Zeilen wirklich löschen?",
    msgMultipleDeleted: "{count} Zeilen gelöscht. {remaining} Zeilen verbleiben.",
    progressTitle: "Artikel werden hinzugefügt...",
    progressOf: "von",
    progressArticles: "Artikel",
    progressPreparing: "Vorbereitung...",
    progressBatch: "Batch {current}/{total} wird verarbeitet...",
    progressRow: "Zeile {row} wird einzeln hinzugefügt...",
    printSelector: ".pplr-_aufdruckoption",
    errorLibrary: "XLSX-Bibliothek nicht geladen. Bitte Seite aktualisieren.",
  },
  dk: {
    buttonText: "📊 Excel/CSV",
    modalTitle: "Upload Excel/CSV fil",
    uploadDragDrop: "Træk og slip en Excel/CSV fil her eller klik for at vælge",
    uploadSelectFile: "Vælg fil",
    uploadSupportedFormats: "Understøttede formater:",
    settingsTitle: "Indstillinger",
    settingsMaxRows: "Maks. rækker:",
    settingsMaxLength: "Maks. tekstlængde:",
    settingsMaxLengthUnit: "tegn",
    settingsBatchSize: "Batch-størrelse:",
    settingsBatchUnit: "varer pr. anmodning",
    currentSettingsTitle: "Aktuelle produktindstillinger:",
    currentSettingsNone: "Ingen specifikke indstillinger",
    previewTitle: "Dataforhåndsvisning",
    previewRow: "Række",
    previewTexts: "Tekster",
    previewQty: "Antal",
    previewActive: "Aktiv",
    previewAction: "Handling",
    previewText: "Tekst",
    previewTruncated: "(afkortet fra",
      propertySelectors: [
    'properties[Trykposition bånd]',
    'properties[_Trykoption]',
    'properties[Trykskabelon tilgængelig]',
    'properties[Skabelon artikelnummer]',
    'properties[Tekst]'
    ],
    controlSelectAll: "Vælg alle",
    controlDeselectAll: "Fravælg alle",
    controlDeleteSelected: "Slet valgte",
    btnCancel: "Annuller",
    btnConfirm: "Til kurv",
    inputSelector: "_Trykoption",
    massentextValue: 'Batch-tekst',
    msgProcessing: "Filen behandles...",
    msgProcessingError: "Fejl ved behandling",
    msgInvalidType: "Ugyldig filtype.",
    msgNoData: "Ingen data fundet.",
    msgWarningTooManyRows: "⚠️ Advarsel: Filen indeholder {total} rækker, men kun de første {max} vil blive behandlet.",
    msgNoValidText: "Ingen gyldige tekstdata fundet.",
    msgRowsLoaded: "{count} rækker blev indlæst.",
    msgNoActiveRows: "Ingen aktive rækker at tilføje.",
    msgVariantNotFound: "Fejl: Variant ID ikke fundet.",
    msgAllAdded: "Alle {count} positioner blev tilføjet ({total} varer i alt)!",
    msgPartialAdded: "{success} af {total} positioner blev tilføjet ({items} varer i alt)!",
    msgWithErrors: " ({errors} fejl)",
    msgAddError: "Fejl ved tilføjelse af varer.",
    msgUnexpectedError: "Uventet fejl ved tilføjelse af varer.",
    msgConfirmDelete: "Vil du virkelig slette denne række?",
    msgRowDeleted: "Række slettet. {count} rækker tilbage.",
    msgAllDeleted: "Alle rækker blev slettet.",
    msgNoRowsToDelete: "Ingen rækker valgt til sletning.",
    msgConfirmDeleteMultiple: "Vil du virkelig slette {count} valgte rækker?",
    msgMultipleDeleted: "{count} rækker slettet. {remaining} rækker tilbage.",
    progressTitle: "Varer tilføjes...",
    progressOf: "af",
    progressArticles: "varer",
    progressPreparing: "Forbereder...",
    progressBatch: "Batch {current}/{total} behandles...",
    progressRow: "Række {row} tilføjes individuelt...",
    printSelector: ".pplr-_aufdruckoption",
    errorLibrary: "XLSX bibliotek ikke indlæst. Genindlæs siden.",
  },
  en: {
    buttonText: "📊 Excel/CSV",
    modalTitle: "Upload Excel/CSV File",
    uploadDragDrop: "Drag & Drop an Excel/CSV file here or click to select",
    uploadSelectFile: "Select File",
    uploadSupportedFormats: "Supported formats:",
    settingsTitle: "Settings",
    settingsMaxRows: "Max. rows:",
    settingsMaxLength: "Max. text length:",
    settingsMaxLengthUnit: "characters",
    settingsBatchSize: "Batch size:",
    settingsBatchUnit: "items per request",
    currentSettingsTitle: "Current Product Settings:",
    currentSettingsNone: "No specific settings",
    previewTitle: "Data Preview",
    previewRow: "Row",
    previewTexts: "Texts",
    previewQty: "Qty",
    previewActive: "Active",
    previewAction: "Action",
    previewText: "Text",
    previewTruncated: "(truncated from",
      propertySelectors: [
    'properties[Ribbon print position]',
    'properties[_Print option]',
    'properties[Print template available]',
    'properties[Template article no.]',
    'properties[Text]'
    ],
    controlSelectAll: "Select All",
    controlDeselectAll: "Deselect All",
    controlDeleteSelected: "Delete Selected",
    btnCancel: "Cancel",
    btnConfirm: "Add to Cart",
    inputSelector: "_Print option",
    massentextValue: 'Bulk text',
    msgProcessing: "Processing file...",
    msgProcessingError: "Error processing",
    msgInvalidType: "Invalid file type.",
    msgNoData: "No data found.",
    msgWarningTooManyRows: "⚠️ Warning: File contains {total} rows, but only the first {max} will be processed.",
    msgNoValidText: "No valid text data found.",
    msgRowsLoaded: "{count} rows successfully loaded.",
    msgNoActiveRows: "No active rows to add.",
    msgVariantNotFound: "Error: Variant ID not found.",
    msgAllAdded: "All {count} positions successfully added ({total} items total)!",
    msgPartialAdded: "{success} of {total} positions successfully added ({items} items total)!",
    msgWithErrors: " ({errors} errors)",
    msgAddError: "Error adding items.",
    msgUnexpectedError: "Unexpected error adding items.",
    msgConfirmDelete: "Do you really want to delete this row?",
    msgRowDeleted: "Row deleted. {count} rows remaining.",
    msgAllDeleted: "All rows have been deleted.",
    msgNoRowsToDelete: "No rows selected for deletion.",
    msgConfirmDeleteMultiple: "Do you really want to delete {count} selected rows?",
    msgMultipleDeleted: "{count} rows deleted. {remaining} rows remaining.",
    progressTitle: "Adding items...",
    progressOf: "of",
    progressArticles: "items",
    progressPreparing: "Preparing...",
    progressBatch: "Processing batch {current}/{total}...",
    progressRow: "Adding row {row} individually...",
    printSelector: ".pplr-_print-option",
    errorLibrary: "XLSX library not loaded. Please refresh the page.",
  },
  es: {
    buttonText: "📊 Excel/CSV",
    modalTitle: "Subir archivo Excel/CSV",
    uploadDragDrop: "Arrastra y suelta un archivo Excel/CSV aquí o haz clic para seleccionar",
    uploadSelectFile: "Seleccionar archivo",
    uploadSupportedFormats: "Formatos compatibles:",
    settingsTitle: "Configuración",
    settingsMaxRows: "Máx. filas:",
    settingsMaxLength: "Máx. longitud de texto:",
    settingsMaxLengthUnit: "caracteres",
    settingsBatchSize: "Tamaño de lote:",
    settingsBatchUnit: "artículos por solicitud",
    currentSettingsTitle: "Configuración actual del producto:",
    currentSettingsNone: "Sin configuración específica",
    previewTitle: "Vista previa de datos",
    previewRow: "Fila",
    previewTexts: "Textos",
    previewQty: "Cant.",
    previewActive: "Activo",
    previewAction: "Acción",
    previewText: "Texto",
    previewTruncated: "(truncado desde",
      propertySelectors: [
    'properties[Posición de impresión en cinta]',
    'properties[_Opción de impresión]',
    'properties[Plantilla de impresión disponible]',
    'properties[Nº de artículo de la plantilla]',
    'properties[Texto]'
     ],
    controlSelectAll: "Seleccionar todo",
    controlDeselectAll: "Deseleccionar todo",
    controlDeleteSelected: "Eliminar seleccionados",
    btnCancel: "Cancelar",
    btnConfirm: "Añadir al carrito",
    inputSelector: "_Opción de impresión",
    massentextValue: 'Texto por lotes',
    msgProcessing: "Procesando archivo...",
    msgProcessingError: "Error al procesar",
    msgInvalidType: "Tipo de archivo no válido.",
    msgNoData: "No se encontraron datos.",
    msgWarningTooManyRows: "⚠️ Advertencia: El archivo contiene {total} filas, pero solo se procesarán las primeras {max}.",
    msgNoValidText: "No se encontraron datos de texto válidos.",
    msgRowsLoaded: "{count} filas cargadas correctamente.",
    msgNoActiveRows: "No hay filas activas para agregar.",
    msgVariantNotFound: "Error: ID de variante no encontrado.",
    msgAllAdded: "¡Todas las {count} posiciones agregadas correctamente ({total} artículos en total)!",
    msgPartialAdded: "¡{success} de {total} posiciones agregadas correctamente ({items} artículos en total)!",
    msgWithErrors: " ({errors} errores)",
    msgAddError: "Error al agregar artículos.",
    msgUnexpectedError: "Error inesperado al agregar artículos.",
    msgConfirmDelete: "¿Realmente deseas eliminar esta fila?",
    msgRowDeleted: "Fila eliminada. {count} filas restantes.",
    msgAllDeleted: "Todas las filas han sido eliminadas.",
    msgNoRowsToDelete: "No hay filas seleccionadas para eliminar.",
    msgConfirmDeleteMultiple: "¿Realmente deseas eliminar {count} filas seleccionadas?",
    msgMultipleDeleted: "{count} filas eliminadas. {remaining} filas restantes.",
    progressTitle: "Agregando artículos...",
    progressOf: "de",
    progressArticles: "artículos",
    progressPreparing: "Preparando...",
    progressBatch: "Procesando lote {current}/{total}...",
    progressRow: "Agregando fila {row} individualmente...",
    printSelector: ".pplr-_opcin-de-impresin",
    errorLibrary: "Biblioteca XLSX no cargada. Actualiza la página.",
  },
  nl: {
    buttonText: "📊 Excel/CSV",
    modalTitle: "Excel/CSV bestand uploaden",
    uploadDragDrop: "Sleep een Excel/CSV bestand hierheen of klik om te selecteren",
    uploadSelectFile: "Bestand selecteren",
    uploadSupportedFormats: "Ondersteunde formaten:",
    settingsTitle: "Instellingen",
    settingsMaxRows: "Max. rijen:",
    settingsMaxLength: "Max. tekstlengte:",
    settingsMaxLengthUnit: "tekens",
    settingsBatchSize: "Batch-grootte:",
    settingsBatchUnit: "artikelen per verzoek",
    currentSettingsTitle: "Huidige productinstellingen:",
    currentSettingsNone: "Geen specifieke instellingen",
    previewTitle: "Gegevensvoorbeeld",
    previewRow: "Rij",
    previewTexts: "Teksten",
    previewQty: "Aantal",
    previewActive: "Actief",
    previewAction: "Actie",
    previewText: "Tekst",
    previewTruncated: "(ingekort vanaf",
      propertySelectors: [
    'properties[Drukpositie lint]',
    'properties[_Opdrukoptie]',
    'properties[_Druksjabloon beschikbaar]',
    'properties[Artikelnummer van het sjabloon]',
    'properties[Tekst]'
    ],
    controlSelectAll: "Alles selecteren",
    controlDeselectAll: "Alles deselecteren",
    controlDeleteSelected: "Geselecteerde verwijderen",
    btnCancel: "Annuleren",
    btnConfirm: "Aan winkelwagen toevoegen",
    inputSelector: "_Opdrukoptie",
    massentextValue: 'Bulktekst',
    msgProcessing: "Bestand wordt verwerkt...",
    msgProcessingError: "Fout bij verwerking",
    msgInvalidType: "Ongeldig bestandstype.",
    msgNoData: "Geen gegevens gevonden.",
    msgWarningTooManyRows: "⚠️ Waarschuwing: Bestand bevat {total} rijen, maar alleen de eerste {max} worden verwerkt.",
    msgNoValidText: "Geen geldige tekstgegevens gevonden.",
    msgRowsLoaded: "{count} rijen succesvol geladen.",
    msgNoActiveRows: "Geen actieve rijen om toe te voegen.",
    msgVariantNotFound: "Fout: Variant ID niet gevonden.",
    msgAllAdded: "Alle {count} posities succesvol toegevoegd ({total} artikelen totaal)!",
    msgPartialAdded: "{success} van {total} posities succesvol toegevoegd ({items} artikelen totaal)!",
    msgWithErrors: " ({errors} fouten)",
    msgAddError: "Fout bij toevoegen van artikelen.",
    msgUnexpectedError: "Onverwachte fout bij toevoegen van artikelen.",
    msgConfirmDelete: "Wilt u deze rij echt verwijderen?",
    msgRowDeleted: "Rij verwijderd. {count} rijen over.",
    msgAllDeleted: "Alle rijen zijn verwijderd.",
    msgNoRowsToDelete: "Geen rijen geselecteerd om te verwijderen.",
    msgConfirmDeleteMultiple: "Wilt u {count} geselecteerde rijen echt verwijderen?",
    msgMultipleDeleted: "{count} rijen verwijderd. {remaining} rijen over.",

    progressTitle: "Artikelen worden toegevoegd...",
    progressOf: "van",
    progressArticles: "artikelen",
    progressPreparing: "Voorbereiden...",
    progressBatch: "Batch {current}/{total} wordt verwerkt...",
    progressRow: "Rij {row} wordt individueel toegevoegd...",
    printSelector: ".pplr-_opdrukoptie",
    errorLibrary: "XLSX bibliotheek niet geladen. Ververs de pagina.",
  }
};

// Helper function to get translated text
function t(key) {
  const lang = getCurrentLanguage();
  return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['de'][key] || key;
}

// Helper function to replace placeholders in translations
function tr(key, replacements = {}) {
  let text = t(key);
  Object.entries(replacements).forEach(([placeholder, value]) => {
    text = text.replace(`{${placeholder}}`, value);
  });
  return text;
}
if (typeof window.KBMassentextLoaded === 'undefined') {
  window.KBMassentextLoaded = true;

  // SETTINGS
  const PRODUCT_EXCEL_CONFIG = {
    // IDs of products for which the function is active
    enabledProductIds: ['15637351792989', '15644932211037', '15644918776157', '15644899311965'],
    
    // Restrictions (fixed in code)
    maxRows: 100,
    maxTextLength: 75,
    
    // Supported formats
    supportedFormats: ['.xlsx', '.xls', '.csv'],
    
    // Batch processing settings
    batchSize: 10, // Number of items to add to cart in one request
    batchDelay: 200 // Delay between batches in milliseconds
  };

  // Global variables
  let productExcelData = [];
  let productExcelModal = null;
  let currentProductData = {};
  let initAttempts = 0;
  const maxInitAttempts = 10;

/**
 * Initialize Excel functionality for product page
 */
window.initProductExcelUpload = function() {
  // Increase attempt counter
  initAttempts++;
  
  // Check if functionality is needed on this page
  if (!isExcelEnabledForCurrentProduct()) {
    console.log('Excel upload not enabled for this product');
    return;
  }
  
  // Get current language
  const currentLang = getCurrentLanguage();
  const t = TRANSLATIONS[currentLang] || TRANSLATIONS.en;
  
  // Check that PPLR elements are loaded - use translated selector if available
  //const printSelector = t.printSelector || '.pplr-_aufdruckoption';
    const printSelector = t.printSelector || '.pplr-_aufdruckoption';
    const aufdruckWrapper = document.querySelector(printSelector);
    console.log('Using selector:', printSelector);
  if (!aufdruckWrapper && initAttempts < maxInitAttempts) {
    console.log(`Excel upload init attempt ${initAttempts}, waiting for PPLR elements...`);
    setTimeout(window.initProductExcelUpload, 300);
    return;
  }
  
  if (!aufdruckWrapper) {
    console.warn('PPLR Aufdruck-Option wrapper not found after max attempts');
    return;
  }
  
  console.log('Initializing Excel upload for product page');
  
  // Add CSS styles
  addProductExcelStyles();
  
  // Add upload button
  addExcelUploadButton();
  
  // Setup Massentext tracking
  setupMassentextWatcher();
  
  // Create modal window
  createProductExcelModal();
};

/**
   * Check if feature is enabled for current product
   */
function isExcelEnabledForCurrentProduct() {
    // Get product ID from JSON on page
    const productJson = document.getElementById('ProductJson-template--23879076872541__main');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        // Преобразуем ID в строку для корректного сравнения
        const productId = String(product.id);
        const isEnabled = PRODUCT_EXCEL_CONFIG.enabledProductIds.includes(productId);
        console.log(`Product ID: ${productId}, Excel enabled: ${isEnabled}`);
        return isEnabled;
      } catch (e) {
        console.error('Error parsing product JSON:', e);
      }
    }
    
    // Alternative method - check via schema.org
    const schemaScript = document.querySelector('script[type="application/ld+json"]');
    if (schemaScript) {
      try {
        const schema = JSON.parse(schemaScript.textContent);
        if (schema.productID) {
          // Преобразуем ID в строку
          const productId = String(schema.productID);
          const isEnabled = PRODUCT_EXCEL_CONFIG.enabledProductIds.includes(productId);
          console.log(`Schema Product ID: ${productId}, Excel enabled: ${isEnabled}`);
          return isEnabled;
        }
      } catch (e) {
        console.error('Error parsing schema JSON:', e);
      }
    }
    
    // Дополнительная проверка через data-id
    const pplrElement = document.querySelector('[data-id]');
    if (pplrElement) {
      const productId = String(pplrElement.dataset.id);
      const isEnabled = PRODUCT_EXCEL_CONFIG.enabledProductIds.includes(productId);
      console.log(`PPLR Product ID: ${productId}, Excel enabled: ${isEnabled}`);
      return isEnabled;
    }
    
    return false;
}
/**
 * Add Excel upload button
 */
function addExcelUploadButton() {
  // Check if button already exists
  if (document.getElementById('product-excel-upload-btn')) {
    console.log('Excel upload button already exists');
    return;
  }
  
  const currentLang = getCurrentLanguage();
  const t = TRANSLATIONS[currentLang] || TRANSLATIONS.en;
  
  // Правильный селектор для NL версии
  const printSelector = t.printSelector || '.pplr-_opdrukoptie';
  const aufdruckWrapper = document.querySelector(printSelector);
  
  if (!aufdruckWrapper) {
    console.error('Aufdruck-Option wrapper not found with selector:', printSelector);
    return;
  }
  
  // Create button
  const button = document.createElement('button');
  button.type = 'button';
  button.id = 'product-excel-upload-btn';
  button.className = 'product-excel-button';
  button.innerHTML = t.buttonText;
  button.onclick = openProductExcelModal;
  
  // Insert after wrapper
  aufdruckWrapper.insertAdjacentElement('afterend', button);
  console.log('Excel upload button added');
  
  // Check initial state
  updateExcelButtonVisibility();
}

/**
 * Setup Massentext change tracking
 */
function setupMassentextWatcher() {
  // Get current language
  const currentLang = getCurrentLanguage();
  const t = TRANSLATIONS[currentLang] || TRANSLATIONS.en;
  
  // Track clicks on Aufdruck-Option dropdown elements
  const printSelector = t.printSelector || '.pplr-_aufdruckoption';
  const dropItems = document.querySelectorAll(`${printSelector} .pplr-drop-item`);
  console.log(`Found ${dropItems.length} Aufdruck-Option dropdown items`);
  
  dropItems.forEach(item => {
    item.addEventListener('click', function() {
      console.log(`Aufdruck-Option clicked: ${this.dataset.value}`);
      // Small delay for value update
      setTimeout(updateExcelButtonVisibility, 100);
    });
  });
  
  // Additionally track input changes
  const inputSelector = t.inputSelector || 'input[name="properties[_Aufdruck-Option]"]';
  const input = document.querySelector(inputSelector);
  if (input) {
    input.addEventListener('change', function() {
      console.log(`Aufdruck-Option input changed: ${this.value}`);
      updateExcelButtonVisibility();
    });
  }
}

/**
 * Update Excel button visibility
 */
function updateExcelButtonVisibility() {
  const button = document.getElementById('product-excel-upload-btn');
  const currentLang = getCurrentLanguage();
  const t = TRANSLATIONS[currentLang] || TRANSLATIONS.en;
  
  // Правильный селектор для input
  const inputSelector = `input[name="properties[${t.inputSelector}]"]`;
  const input = document.querySelector(inputSelector);
  
  if (!button) {
    console.warn('Excel button not found');
    return;
  }
  
  if (!input) {
    console.warn('Input not found with selector:', inputSelector);
    return;
  }
  
  const currentValue = input.value;
  console.log(`Checking visibility for value: "${currentValue}" (expected: "${t.massentextValue}")`);
  
  if (currentValue === t.massentextValue) {
    button.classList.add('visible');
    console.log('Excel button shown');
  } else {
    button.classList.remove('visible');
    console.log('Excel button hidden');
  }
}
    /**
     * Open modal window
     */
    window.openProductExcelModal = function() {
    console.log('Opening Excel modal');
    
    // Gather current product settings
    gatherCurrentProductData();
    
    // Reset data
    productExcelData = [];
    
    // Show modal window
    if (productExcelModal) {
        productExcelModal.style.display = 'block';
        resetProductExcelModal();
    }
    };

/**
 * Gather current product settings
 */
function gatherCurrentProductData() {
  currentProductData = {};
  
  // Get current language
  const currentLang = getCurrentLanguage();
  const t = TRANSLATIONS[currentLang] || TRANSLATIONS.en;
  
  // Collect all available product properties
  const propertySelectors = t.propertySelectors || [
    'properties[Druckposition Band]',
    'properties[_Aufdruck-Option]', 
    'properties[_Druckvorlage vorhanden]',
    'properties[Artikelnr. der Vorlage]',
    'properties[Text]'
  ];
  
  propertySelectors.forEach(selector => {
    const value = getInputValue(selector);
    if (value && value.trim()) {
      // Remove properties[] prefix for key
      const key = selector.replace('properties[', '').replace(']', '');
      currentProductData[key] = value.trim();
    }
  });
  
  // Additionally check all inputs with properties[] in name
  document.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(input => {
    // Check element and parent visibility
    if (isElementVisible(input) && input.value && input.value.trim()) {
      const key = input.name.replace('properties[', '').replace(']', '');
      if (!currentProductData[key]) { // Don't overwrite already found
        currentProductData[key] = input.value.trim();
      }
    }
  });
  
  // Get selected product variant
  const variantSelector = document.querySelector('select[name="id"]') || 
                        document.querySelector('input[name="id"]:checked');
  if (variantSelector) {
    currentProductData.variantId = variantSelector.value;
  }
  
  console.log('Gathered product data:', currentProductData);
}

    /**
     * Check element visibility
     */
    function isElementVisible(element) {
    if (!element) return false;

    let current = element;
    while (current && current !== document) {
        const style = window.getComputedStyle(current);

        if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.opacity === '0'
        ) {
        return false;
        }

        // Универсальная проверка для PPLR/Zepto скрытых блоков
        if (current.classList?.contains('pplr-wrapper')) {
        const wrapper = current.closest('.pplr-wrapper');
        if (wrapper && window.getComputedStyle(wrapper).display === 'none') {
            return false;
        }
        }

        current = current.parentElement;
    }

    return true;
    }


  /**
   * Get input value by name
   */
  function getInputValue(name) {
    const input = document.querySelector(`input[name="${name}"], select[name="${name}"]`);
    return input ? input.value : '';
  }

    /**
     * Show progress overlay during cart operations
     */
    function showProgressOverlay(total) {
    // Определяем язык и словарь
    const lang = getCurrentLanguage();
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

    // Удаляем старый оверлей если есть
    const existingOverlay = document.getElementById('upload-progress-overlay');
    if (existingOverlay) {
        existingOverlay.remove();
    }

    const overlay = document.createElement('div');
    overlay.id = 'upload-progress-overlay';
    overlay.innerHTML = `
        <div class="progress-content">
        <h3>${dict.progressTitle}</h3>
        <div class="progress-bar">
            <div class="progress-fill" id="progress-fill"></div>
        </div>
        <div class="progress-text">
            <span id="progress-current">0</span> ${dict.progressOf} 
            <span id="progress-total">${total}</span> ${dict.progressArticles}
        </div>
        <div class="progress-details">
            <div id="progress-status">${dict.progressPreparing}</div>
        </div>
        </div>
    `;
    document.body.appendChild(overlay);
    }

  /**
   * Update progress indicator
   */
  function updateProgress(current, total, status = '') {
    const fill = document.getElementById('progress-fill');
    const currentSpan = document.getElementById('progress-current');
    const statusDiv = document.getElementById('progress-status');
    
    if (!fill || !currentSpan) return;
    
    const percentage = Math.min((current / total) * 100, 100);
    
    fill.style.width = percentage + '%';
    currentSpan.textContent = current;
    
    if (status) {
      statusDiv.textContent = status;
    }
  }

  /**
   * Hide progress overlay
   */
  function hideProgressOverlay() {
    const overlay = document.getElementById('upload-progress-overlay');
    if (overlay) {
      overlay.remove();
    }
  }

    /**
     * Create modal window
     */
    function createProductExcelModal() {
    if (productExcelModal) {
        console.log('Excel modal already created');
        return;
    }

    const lang = getCurrentLanguage();
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

    const modal = document.createElement('div');
    modal.id = 'productExcelModal';
    modal.className = 'product-excel-modal';

    modal.innerHTML = `
        <div class="product-excel-modal-content">
        <div class="product-excel-header">
            <h3>${dict.modalTitle}</h3>
            <span class="product-excel-close" onclick="closeProductExcelModal()">&times;</span>
        </div>
        
        <div class="product-excel-body">
            <div class="product-excel-upload-area" id="productUploadArea">
            <p>${dict.uploadDragDrop}</p>
            <input type="file" id="productExcelFile" class="product-excel-file-input" 
                    accept="${PRODUCT_EXCEL_CONFIG.supportedFormats.join(',')}" 
                    onchange="handleProductExcelFile(event)">
            <label for="productExcelFile" class="product-excel-upload-label">
                ${dict.uploadSelectFile}
            </label>
            <p><small>${dict.uploadSupportedFormats} ${PRODUCT_EXCEL_CONFIG.supportedFormats.join(', ')}</small></p>
            </div>
            
            <div class="product-excel-settings" id="productExcelSettings" style="display: none;">
            <!---
            <h4>${dict.settingsTitle}</h4>
            <div class="product-excel-row">
                <div class="product-excel-info-box">
                <p><strong>${dict.settingsMaxRows}</strong> ${PRODUCT_EXCEL_CONFIG.maxRows}</p>
                <p><strong>${dict.settingsMaxLength}</strong> ${PRODUCT_EXCEL_CONFIG.maxTextLength} ${dict.settingsMaxLengthUnit}</p>
                <p><strong>${dict.settingsBatchSize}</strong> ${PRODUCT_EXCEL_CONFIG.batchSize} ${dict.settingsBatchUnit}</p>
                </div>
            </div> 
            </div> -->
            
            <div class="product-excel-current-settings" id="productCurrentSettings">
            <h4>${dict.currentSettingsTitle}</h4>
            <div id="productSettingsDisplay">${dict.currentSettingsNone}</div>
            </div>
            
            <div class="product-excel-preview" id="productExcelPreview" style="display: none;">
            <h4>${dict.previewTitle}</h4>
            <div id="productPreviewContent"></div>
            </div>
            
            <div class="product-excel-feedback" id="productExcelFeedback"></div>
        </div>
        
        <div class="product-excel-actions">
            <button class="product-excel-btn-cancel" onclick="closeProductExcelModal()">
            ${dict.btnCancel}
            </button>
            <button class="product-excel-btn-confirm" id="productExcelConfirm" 
                    onclick="confirmProductExcelUpload()" disabled>
            ${dict.btnConfirm}
            </button>
        </div>
        </div>
    `;

    document.body.appendChild(modal);
    productExcelModal = modal;
    console.log('Excel modal created');

    // Setup drag & drop
    setupProductExcelDragDrop();

    // Close on outside click
    modal.onclick = function(event) {
        if (event.target === modal) {
        closeProductExcelModal();
        }
    };
 }


  /**
   * Setup drag & drop for modal window
   */
  function setupProductExcelDragDrop() {
    const uploadArea = document.getElementById('productUploadArea');
    if (!uploadArea) return;
    
    uploadArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      uploadArea.classList.add('dragover');
    });
    
    uploadArea.addEventListener('dragleave', () => {
      uploadArea.classList.remove('dragover');
    });
    
    uploadArea.addEventListener('drop', (e) => {
      e.preventDefault();
      uploadArea.classList.remove('dragover');
      
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        processProductExcelFile(files[0]);
      }
    });
  }

    /**
     * Reset modal window state
     */
    function resetProductExcelModal() {
    document.getElementById('productExcelFile').value = '';
    document.getElementById('productExcelSettings').style.display = 'none';
    document.getElementById('productExcelPreview').style.display = 'none';
    document.getElementById('productExcelConfirm').disabled = true;
    document.getElementById('productExcelFeedback').innerHTML = '';
    
    // Show current product settings
    displayCurrentProductSettings();
    }

    /**
     * Display current product settings
     */
    function displayCurrentProductSettings() {
    const display = document.getElementById('productSettingsDisplay');
    if (!display) return;

    const lang = getCurrentLanguage();
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

    let html = '';
    Object.entries(currentProductData).forEach(([key, value]) => {
        if (value && value.trim() && key !== 'variantId' && !key.startsWith('_')) {
        html += `<p><strong>${key}:</strong> ${value}</p>`;
        }
    });

    display.innerHTML = html || `<p>${dict.currentSettingsNone}</p>`;
    }


/**
 * Handle file selection
 */
window.handleProductExcelFile = function(event) {
  const file = event.target.files[0];
  if (file) {
    processProductExcelFile(file);
  }
};

/**
 * Process Excel/CSV file
 */
function processProductExcelFile(file) {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  console.log(`Processing file: ${file.name}`);
  
  const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
  
  if (!PRODUCT_EXCEL_CONFIG.supportedFormats.includes(fileExtension)) {
    showProductExcelFeedback(dict.msgInvalidType, 'error');
    return;
  }
  
  showProductExcelFeedback(dict.msgProcessing, 'info');
  
  const reader = new FileReader();
  reader.onload = function(e) {
    try {
      let rawData;
      
      if (fileExtension === '.csv') {
        // Process CSV
        const csvText = e.target.result;
        const lines = csvText.split('\n').filter(line => line.trim());
        rawData = lines.map(line => {
          return line.split(',').map(cell => cell.trim().replace(/^["']|["']$/g, ''));
        });
      } else {
        // Check if XLSX library is loaded
        if (typeof XLSX === 'undefined') {
          showProductExcelFeedback(dict.errorLibrary, 'error');
          return;
        }
        
        // Process Excel
        const workbook = XLSX.read(e.target.result, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        rawData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      }
      
      processProductExcelData(rawData);
    } catch (error) {
      console.error('File processing error:', error);
      showProductExcelFeedback(dict.msgProcessingError + ': ' + error.message, 'error');
    }
  };
  
  if (fileExtension === '.csv') {
    reader.readAsText(file);
  } else {
    reader.readAsArrayBuffer(file);
  }
}

    /**
     * Process data from Excel/CSV
     */
    function processProductExcelData(rawData) {
    const lang = getCurrentLanguage();
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

    console.log(`Processing ${rawData.length} rows of data`);
    
    if (rawData.length === 0) {
        showProductExcelFeedback(dict.msgNoData, 'error');
        return;
    }
    
    // Use fixed limits from configuration
    const maxRows = PRODUCT_EXCEL_CONFIG.maxRows;
    const maxTextLength = PRODUCT_EXCEL_CONFIG.maxTextLength;
    
    // Check if file exceeds maximum row count
    const totalDataRows = rawData.length - 1; // minus header
    if (totalDataRows > maxRows) {
        const msg = dict.msgWarningTooManyRows
        .replace('{total}', totalDataRows)
        .replace('{max}', maxRows);
        showProductExcelFeedback(msg, 'warning');
    }
    
    // Skip header, take only data rows
    const dataRows = rawData.slice(1).slice(0, maxRows);
    
    productExcelData = dataRows.map((row, index) => {
        const texts = [];
        
        // Process each cell in row
        row.forEach((cell, cellIndex) => {
        if (cell && cell.toString().trim()) {
            const text = cell.toString().trim();
            if (text.length > 0) {
            const isOverLimit = text.length > maxTextLength;
            texts.push({
                index: cellIndex + 1,
                value: text.substring(0, maxTextLength),
                original: text,
                isOverLimit: isOverLimit // Flag for length exceeded
            });
            }
        }
        });
        
        return {
        rowNumber: index + 1,
        texts: texts,
        quantity: 1, // Default quantity
        enabled: true // Default enabled
        };
    }).filter(row => row.texts.length > 0); // Exclude empty rows
    
    console.log(`Processed ${productExcelData.length} valid rows`);
    
    if (productExcelData.length === 0) {
        showProductExcelFeedback(dict.msgNoValidText, 'error');
        return;
    }
    
    // Show settings and preview
    document.getElementById('productExcelSettings').style.display = 'block';
    showProductExcelPreview();
    document.getElementById('productExcelConfirm').disabled = false;
    
    const successMsg = dict.msgRowsLoaded.replace('{count}', productExcelData.length);
    showProductExcelFeedback(successMsg, 'success');
    }


    /**
     * Show data preview
     */
    function showProductExcelPreview() {
    const previewContent = document.getElementById('productPreviewContent');
    if (!previewContent) return;

    const lang = getCurrentLanguage();
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

    let html = '<table class="product-excel-table">';
    html += `<thead><tr>
        <th>${dict.previewRow}</th>
        <th>${dict.previewTexts}</th>
        <th>${dict.previewQty}</th>
        <th>${dict.previewActive}</th>
        <th>${dict.previewAction}</th>
    </tr></thead><tbody>`;

    // Show ALL rows with editing capability
    productExcelData.forEach((row, index) => {
        html += `<tr data-index="${index}">`;
        html += `<td>${row.rowNumber}</td>`;
        html += `<td>`;

        row.texts.forEach((text, textIndex) => {
        const textClass = text.isOverLimit ? 'text-over-limit' : '';
        html += `<div class="${textClass}">`;
        html += `${dict.previewText} ${textIndex + 1}: `;
        html += `<input type="text" value="${text.value}" 
            class="excel-row-text" data-text-index="${textIndex}" 
            style="width: 200px; padding: 2px 4px; margin: 2px 0;" 
            maxlength="${PRODUCT_EXCEL_CONFIG.maxTextLength}">`;
        if (text.isOverLimit) {
            html += ` <small style="color: #d32f2f;">(${dict.previewTruncated} ${text.original.length})</small>`;
        }
        html += `</div>`;
        });

        html += `</td>`;
        html += `<td><input type="number" min="1" value="${row.quantity || 1}" 
        class="excel-row-qty" style="width: 70px; padding: 4px;"></td>`;
        html += `<td><input type="checkbox" class="excel-row-enabled" ${row.enabled !== false ? 'checked' : ''}></td>`;
        html += `<td><button type="button" class="excel-row-remove" 
        onclick="removeExcelRow(${index})" title="${dict.msgConfirmDelete}">×</button></td>`;
        html += `</tr>`;
    });

    html += '</tbody></table>';

    // Add control buttons
    html += '<div class="excel-table-controls">';
    html += `<button type="button" onclick="selectAllRows(true)" class="excel-control-btn">${dict.controlSelectAll}</button>`;
    html += `<button type="button" onclick="selectAllRows(false)" class="excel-control-btn">${dict.controlDeselectAll}</button>`;
    html += `<button type="button" onclick="removeSelectedRows()" class="excel-control-btn excel-danger">${dict.controlDeleteSelected}</button>`;
    html += '</div>';

    previewContent.innerHTML = html;
    document.getElementById('productExcelPreview').style.display = 'block';

    // Add event handlers for changes
    setupTableEventListeners();
    }


/**
 * Setup event handlers for table
 */
function setupTableEventListeners() {
  // Text change handlers
  document.querySelectorAll('.excel-row-text').forEach(input => {
    input.addEventListener('input', function() {
      const rowIndex = parseInt(this.closest('tr').dataset.index);
      const textIndex = parseInt(this.dataset.textIndex);
      if (productExcelData[rowIndex] && productExcelData[rowIndex].texts[textIndex]) {
        productExcelData[rowIndex].texts[textIndex].value = this.value;
        productExcelData[rowIndex].texts[textIndex].isOverLimit =
          this.value.length > PRODUCT_EXCEL_CONFIG.maxTextLength;
      }
    });
  });

  // Quantity change handlers
  document.querySelectorAll('.excel-row-qty').forEach(input => {
    input.addEventListener('change', function() {
      const rowIndex = parseInt(this.closest('tr').dataset.index);
      if (productExcelData[rowIndex]) {
        productExcelData[rowIndex].quantity = Math.max(1, parseInt(this.value) || 1);
      }
    });
  });

  // Checkbox handlers
  document.querySelectorAll('.excel-row-enabled').forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      const rowIndex = parseInt(this.closest('tr').dataset.index);
      if (productExcelData[rowIndex]) {
        productExcelData[rowIndex].enabled = this.checked;
      }
    });
  });
}

/**
 * Remove row by index
 */
window.removeExcelRow = function(index) {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  if (confirm(dict.msgConfirmDelete)) {
    productExcelData.splice(index, 1);

    // Update row numbers
    productExcelData.forEach((row, newIndex) => {
      row.rowNumber = newIndex + 1;
    });

    // Update display
    showProductExcelPreview();

    // Check if data remains
    if (productExcelData.length === 0) {
      document.getElementById('productExcelConfirm').disabled = true;
      showProductExcelFeedback(dict.msgAllDeleted, 'warning');
    } else {
      const msg = dict.msgRowDeleted.replace('{count}', productExcelData.length);
      showProductExcelFeedback(msg, 'info');
    }
  }
};

/**
 * Select/deselect all rows
 */
window.selectAllRows = function(select) {
  document.querySelectorAll('.excel-row-enabled').forEach(checkbox => {
    checkbox.checked = select;
    const rowIndex = parseInt(checkbox.closest('tr').dataset.index);
    if (productExcelData[rowIndex]) {
      productExcelData[rowIndex].enabled = select;
    }
  });
};

/**
 * Remove selected rows
 */
window.removeSelectedRows = function() {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  const enabledRows = productExcelData.filter(row => row.enabled !== false);
  const disabledCount = productExcelData.length - enabledRows.length;

  if (disabledCount === 0) {
    alert(dict.msgNoRowsToDelete);
    return;
  }

  const confirmMsg = dict.msgConfirmDeleteMultiple.replace('{count}', disabledCount);
  if (confirm(confirmMsg)) {
    // Keep only enabled rows
    productExcelData = enabledRows;

    // Update row numbers
    productExcelData.forEach((row, newIndex) => {
      row.rowNumber = newIndex + 1;
    });

    // Update display
    showProductExcelPreview();

    // Check if data remains
    if (productExcelData.length === 0) {
      document.getElementById('productExcelConfirm').disabled = true;
      showProductExcelFeedback(dict.msgAllDeleted, 'warning');
    } else {
      const msg = dict.msgMultipleDeleted
        .replace('{count}', disabledCount)
        .replace('{remaining}', productExcelData.length);
      showProductExcelFeedback(msg, 'success');
    }
  }
};


/**
 * Add items to cart in batches using Shopify Cart API
 */
async function addItemsToCartInBatches(items, variantId) {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  const batchSize = PRODUCT_EXCEL_CONFIG.batchSize;
  let successCount = 0;
  let errorCount = 0;
  let processedItems = 0;
  
  // Calculate total items for progress
  const totalItems = items.reduce((sum, item) => sum + (item.quantity || 1), 0);
  
  console.log(`Processing ${items.length} rows in batches of ${batchSize}`);
  
  // Split items into batches
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchNumber = Math.floor(i / batchSize) + 1;
    const totalBatches = Math.ceil(items.length / batchSize);

    // Сообщение из словаря
    const statusMsg = dict.progressBatch
      .replace('{current}', batchNumber)
      .replace('{total}', totalBatches);

    updateProgress(processedItems, totalItems, statusMsg);
    
    try {
      // Try batch add first
      const batchResult = await addBatchToCart(batch, variantId);
      
      if (batchResult.success) {
        successCount += batch.length;
        processedItems += batch.reduce((sum, item) => sum + (item.quantity || 1), 0);
        console.log(`Batch ${batchNumber} successfully added`);
      } else {
        // If batch fails, try individual items
        console.log(`Batch ${batchNumber} failed, trying individual items`);
        const individualResult = await addItemsIndividually(batch, variantId, processedItems, totalItems);
        successCount += individualResult.successCount;
        errorCount += individualResult.errorCount;
        processedItems += individualResult.processedItems;
      }
    } catch (error) {
      console.error(`Batch ${batchNumber} error:`, error);
      // Fallback to individual processing
      const individualResult = await addItemsIndividually(batch, variantId, processedItems, totalItems);
      successCount += individualResult.successCount;
      errorCount += individualResult.errorCount;
      processedItems += individualResult.processedItems;
    }
    
    // Small pause between batches
    if (i + batchSize < items.length) {
      await new Promise(resolve => setTimeout(resolve, PRODUCT_EXCEL_CONFIG.batchDelay));
    }
  }
  
  return { successCount, errorCount, totalItems };
}
/**
 * Add batch of items to cart using Shopify Cart API
 */
async function addBatchToCart(batch, variantId) {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  try {
    // Prepare items for batch add
    const cartItems = batch.map(row => {
      const item = {
        id: variantId,
        quantity: row.quantity || 1,
        properties: {}
      };
      
      // Add base product settings
      Object.entries(currentProductData).forEach(([key, value]) => {
        if (value && value.trim() && key !== 'variantId') {
          item.properties[key] = value;
        }
      });
      
      // Add texts from row (локализованный ключ)
      row.texts.forEach((text, index) => {
        const textKey = `${dict.previewText} ${index + 1}`;
        item.properties[textKey] = text.value;
      });
      
      // Add row number for identification (локализованный ключ)
      const rowKey = dict.previewRow;
      item.properties[rowKey] = row.rowNumber;
      
      return item;
    });
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: cartItems })
    });
    
    if (response.ok) {
      const result = await response.json();
      console.log('Batch add successful:', result);
      return { success: true, data: result };
    } else {
      const errorText = await response.text();
      console.error('Batch add failed:', errorText);
      return { success: false, error: errorText };
    }
  } catch (error) {
    console.error('Batch add error:', error);
    return { success: false, error: error.message };
  }
}
/**
 * Add items individually (fallback method)
 */
async function addItemsIndividually(items, variantId, startProcessedItems, totalItems) {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  let successCount = 0;
  let errorCount = 0;
  let processedItems = 0;
  
  for (const row of items) {
    const quantity = row.quantity || 1;

    // Локализованный статус
    const statusMsg = dict.progressRow.replace('{row}', row.rowNumber);
    updateProgress(startProcessedItems + processedItems, totalItems, statusMsg);
    
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      
      // Add base product settings
      Object.entries(currentProductData).forEach(([key, value]) => {
        if (value && value.trim() && key !== 'variantId') {
          formData.append(`properties[${key}]`, value);
        }
      });
      
      // Add texts from row (локализованный ключ)
      row.texts.forEach((text, index) => {
        const textKey = `${dict.previewText} ${index + 1}`;
        formData.append(`properties[${textKey}]`, text.value);
      });
      
      // Add row number for identification (локализованный ключ)
      formData.append(`properties[${dict.previewRow}]`, row.rowNumber);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        successCount++;
        console.log(`Successfully added row ${row.rowNumber} individually`);
      } else {
        errorCount++;
        const errorText = await response.text();
        console.error(`Failed to add row ${row.rowNumber}:`, errorText);
      }
    } catch (error) {
      errorCount++;
      console.error(`Error adding row ${row.rowNumber}:`, error);
    }
    
    processedItems += quantity;
    
    // Small pause between individual requests
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  
  return { successCount, errorCount, processedItems };
}
/**
 * Confirm and add products to cart using batch processing
 */
window.confirmProductExcelUpload = async function() {
  const lang = getCurrentLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;

  // Filter only active rows
  const activeRows = productExcelData.filter(row => row.enabled !== false);
  
  if (activeRows.length === 0) {
    showProductExcelFeedback(dict.msgNoActiveRows, 'error');
    return;
  }
  
  console.log(`Adding ${activeRows.length} items to cart using batch processing`);
  
  // Calculate total items for progress
  const totalItems = activeRows.reduce((sum, row) => sum + (row.quantity || 1), 0);
  
  // Show progress overlay
  showProgressOverlay(totalItems);
  
  // Get variant ID
  const variantId = currentProductData.variantId || getDefaultVariantId();
  if (!variantId) {
    hideProgressOverlay();
    showProductExcelFeedback(dict.msgVariantNotFound, 'error');
    return;
  }
  
  console.log(`Using variant ID: ${variantId}`);
  
  try {
    // Use batch processing
    const result = await addItemsToCartInBatches(activeRows, variantId);
    
    // Hide progress overlay
    hideProgressOverlay();
    
    console.log(`Cart update complete. Success: ${result.successCount}, Errors: ${result.errorCount}, Total items: ${result.totalItems}`);
    
    if (result.successCount > 0) {
      let successMessage;
      
      if (result.successCount === activeRows.length) {
        successMessage = dict.msgAllAdded
          .replace('{count}', result.successCount)
          .replace('{total}', result.totalItems);
      } else {
        successMessage = dict.msgPartialAdded
          .replace('{success}', result.successCount)
          .replace('{total}', activeRows.length)
          .replace('{items}', result.totalItems);
      }
      
      if (result.errorCount > 0) {
        successMessage += dict.msgWithErrors.replace('{errors}', result.errorCount);
      }
      
      showProductExcelFeedback(successMessage, 'success');
      
      setTimeout(() => {
        closeProductExcelModal();
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        }
      }, 2000);
    } else {
      showProductExcelFeedback(dict.msgAddError, 'error');
    }
  } catch (error) {
    hideProgressOverlay();
    console.error('Cart update error:', error);
    showProductExcelFeedback(dict.msgUnexpectedError, 'error');
  }
};


  /**
   * Get default variant ID
   */
  function getDefaultVariantId() {
    // Try to get from select
      const hiddenSelect = document.querySelector('#product-select-template--23879076872541__main');
    if (hiddenSelect && hiddenSelect.value) {
        return hiddenSelect.value; // Вернет 58594471117149
    }
    const select = document.querySelector('select[name="id"]');
    if (select && select.value) {
      return select.value;
    }
    
    // Try to get from radio buttons
    const radio = document.querySelector('input[name="id"]:checked');
    if (radio) {
      return radio.value;
    }
    
    // Try to get from JSON data
    const productJson = document.getElementById('ProductJson-template--23879076872541__main');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        if (product.variants && product.variants.length > 0) {
          return product.variants[0].id.toString();
        }
      } catch (e) {
        console.error('Error parsing product JSON for variant ID:', e);
      }
    }
    
    return null;
  }

  /**
   * Show message
   */
  function showProductExcelFeedback(message, type) {
    const feedback = document.getElementById('productExcelFeedback');
    if (!feedback) return;
    
    let className = 'info';
    if (type === 'success') className = 'success';
    else if (type === 'error') className = 'error';
    else if (type === 'warning') className = 'warning';
    
    feedback.innerHTML = `<div class="product-excel-message ${className}">${message}</div>`;
  }

  /**
   * Close modal window
   */
  window.closeProductExcelModal = function() {
    if (productExcelModal) {
      productExcelModal.style.display = 'none';
    }
    productExcelData = [];
    currentProductData = {};
    hideProgressOverlay(); // Ensure overlay is hidden
    console.log('Excel modal closed');
  };

  /**
   * Add CSS styles
   */
  function addProductExcelStyles() {
    if (document.getElementById('product-excel-styles')) {
      console.log('Excel styles already added');
      return;
    }
    
    const style = document.createElement('style');
    style.id = 'product-excel-styles';
    style.textContent = `
      /* Excel Upload Button */
      .product-excel-button {
        background:rgb(255, 255, 255);
        color: #333;
        border: 1px solid #ccc;
        padding: 4px 8px;
        border-radius: 0px;
        font-size: 16px;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        cursor: pointer;
        margin-left: 0px;
        display: none;
        transition: all 0.1s ease;
        box-shadow: 0 1px 2px rgba(0,0,0,0.1);
        text-shadow: 0 1px 0 rgba(255,255,255,0.5);
      }

      .product-excel-button:hover {
        background: #e8e8e8;
        background: linear-gradient(to bottom, #f0f0f0, #e0e0e0);
        border-color: #999;
      }

      .product-excel-button:active {
        background: #e0e0e0;
        background: linear-gradient(to bottom, #e0e0e0, #f0f0f0);
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
        transform: translateY(1px);
      }

      .product-excel-button.visible {
        display: inline-block !important;
      }
      
      /* Excel Modal */
      .product-excel-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        z-index: 10000;
        display: none;
        align-items: center;
        justify-content: center;
      }
      
      .product-excel-modal[style*="display: block"] {
        display: flex !important;
      }
      
      .product-excel-modal-content {
        background: white;
        border-radius: 8px;
        padding: 20px;
        max-width: 90vw;
        max-height: 90vh;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
      }
      
      .product-excel-body {
        flex: 1;
        overflow-y: auto;
        padding-right: 10px;
        margin-bottom: 10px;
      }
      
      .product-excel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        flex-shrink: 0;
      }
      
      .product-excel-header h3 {
        margin: 0;
        font-size: 18px;
        font-weight: bold;
      }
      
      .product-excel-close {
        color: #910045;
        border: none;
        border-radius: 3px;
        padding: 2px 8px;
        cursor: pointer;
        font-size: 32px;
      }
      .product-excel-close:hover {
        background: #d32f2f;
      }
      
      /* Upload Area */
      .product-excel-upload-area {
        border: 2px dashed #4CAF50;
        border-radius: 4px;
        padding: 20px;
        text-align: center;
        margin: 15px 0;
        background: #f9f9f9;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      .product-excel-upload-area:hover,
      .product-excel-upload-area.dragover {
        background: #f0f8f0;
        border-color: #45a049;
      }
      
      .product-excel-file-input {
        display: none;
      }
      
      .product-excel-upload-label {
        display: inline-block;
        padding: 6px 12px;
        background: #f0f0f0;
        color: #333;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;
        margin: 10px 0;
        font-family: system-ui, -apple-system, sans-serif;
        font-size: 13px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      }
      .product-excel-upload-label:hover {
        background: #e8e8e8;
        border-color: #999;
      }
      
      /* Settings */
      .product-excel-settings {
        background: #f5f5f5;
        padding: 15px;
        border-radius: 4px;
        margin: 15px 0;
        border: 1px solid #ddd;
      }
      
      .product-excel-settings h4 {
        margin: 0 0 10px 0;
        font-weight: bold;
      }
      
      .product-excel-row {
        display: flex;
        gap: 15px;
        flex-wrap: wrap;
      }
      
      .product-excel-row label {
        display: flex;
        flex-direction: column;
        font-weight: bold;
        min-width: 120px;
      }
      
      .product-excel-row input {
        margin-top: 5px;
        padding: 4px 8px;
        border: 1px solid #ddd;
        border-radius: 3px;
      }
      
      /* Current Settings */
      .product-excel-current-settings {
        background: #f5f5f5;
        padding: 15px;
        border-radius: 4px;
        margin: 15px 0;
        border: 1px solid #ddd;
      }
      
      .product-excel-current-settings h4 {
        margin: 0 0 10px 0;
        font-weight: bold;
      }
      
      /* Data Table */
      .product-excel-table {
        width: 100%;
        border-collapse: collapse;
        margin: 10px 0;
      }
      
      .product-excel-table th,
      .product-excel-table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }
      
      .product-excel-table th {
        background-color: #f5f5f5;
        font-weight: bold;
      }
      
      .product-excel-table tr:nth-child(even) {
        background-color: #f9f9f9;
      }
      
      /* Table Controls */
      .excel-table-controls {
        margin: 10px 0;
        padding: 10px;
        background: #f0f8f0;
        border-radius: 4px;
        border: 1px solid #ddd;
      }
      
      .excel-control-btn {
        padding: 4px 8px;
        margin: 0 5px 5px 0;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        font-size: 12px;
        background: #2196F3;
        color: white;
      }
      
      .excel-control-btn:hover {
        background: #1976D2;
      }
      
      .excel-control-btn.excel-danger {
        background: #f44336;
      }
      
      .excel-control-btn.excel-danger:hover {
        background: #d32f2f;
      }
      
      /* Row Controls */
      .excel-row-text {
        border: 1px solid #ddd;
        border-radius: 3px;
        font-size: 12px;
      }
      
      .excel-row-text:focus {
        border-color: #4CAF50;
        outline: none;
      }
      
      .excel-row-qty {
        border: 1px solid #ddd;
        border-radius: 3px;
        text-align: center;
      }
      
      .excel-row-enabled {
        transform: scale(1.2);
        cursor: pointer;
      }
      
      .excel-row-remove {
        color: #910045;
        border: none;
        border-radius: 3px;
        padding: 2px 6px;
        cursor: pointer;
        font-size: 32px;
      }
      .excel-row-remove:hover {
        background: #73264d;
      }
      
      /* Action Buttons - Fixed position */
      .product-excel-actions {
        margin-top: 15px;
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        flex-shrink: 0;
        background: white;
        padding-top: 15px;
        border-top: 1px solid #ddd;
      }
      
      .product-excel-actions button {
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
      }
      
      .product-excel-btn-cancel {
        background: #f44336;
        color: white;
      }
      .product-excel-btn-cancel:hover {
        background: #d32f2f;
      }
      
      .product-excel-btn-confirm {
        background: #910045;
        color: white;
      }
      .product-excel-btn-confirm:hover:not(:disabled) {
        background: #73264d;
      }
      .product-excel-btn-confirm:disabled {
        background: #ccc;
        cursor: not-allowed;
        opacity: 0.6;
      }
      
      /* Settings - Info Box */
      .product-excel-info-box {
        background: #e8f5e8;
        padding: 10px;
        border-radius: 4px;
        border-left: 4px solid #4CAF50;
      }
      
      .product-excel-info-box p {
        margin: 5px 0;
        font-size: 14px;
      }
      
      /* Text Over Limit Highlighting */
      .text-over-limit {
        color: #d32f2f !important;
        background-color: #ffebee;
        padding: 2px 4px;
        border-radius: 3px;
      }
      
      /* Warning Messages */
      .product-excel-message.warning {
        background: #fff3cd;
        color: #856404;
        border: 1px solid #ffeaa7;
      }
      
      /* Feedback Messages */
      .product-excel-message {
        padding: 10px;
        border-radius: 4px;
        margin: 10px 0;
      }
      
      .product-excel-message.success {
        background: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
      }
      
      .product-excel-message.error {
        background: #f8d7da;
        color: #721c24;
        border: 1px solid #f5c6cb;
      }
      
      .product-excel-message.info {
        background: #d1ecf1;
        color: #0c5460;
        border: 1px solid #bee5eb;
      }
      
      /* Progress Overlay */
      #upload-progress-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .progress-content {
        background: white;
        padding: 30px;
        border-radius: 8px;
        text-align: center;
        min-width: 300px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      }

      .progress-content h3 {
        margin: 0 0 20px 0;
        color: #333;
      }

      .progress-bar {
        width: 100%;
        height: 20px;
        background: #f0f0f0;
        border-radius: 10px;
        margin: 20px 0;
        overflow: hidden;
        border: 1px solid #ddd;
      }

      .progress-fill {
        height: 100%;
        background: #4CAF50;
        background: linear-gradient(to right, #4CAF50, #45a049);
        transition: width 0.3s ease;
        width: 0%;
      }

      .progress-text {
        font-size: 16px;
        font-weight: bold;
        margin: 10px 0;
        color: #333;
      }

      .progress-details {
        font-size: 14px;
        color: #666;
        margin-top: 10px;
      }
    `;
    
    document.head.appendChild(style);
    console.log('Excel styles added');
  }

  console.log('KB-Massentext.js with batch processing loaded successfully');

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initProductExcelUpload);
  } else {
    // DOM is already loaded
    setTimeout(window.initProductExcelUpload, 100);
  }

} // End of KBMassentextLoaded check